import { useCallback } from 'react';
import { useLocation } from 'quartz-routing/react-router';
import { useACNavigate } from 'academy-common-lib/hooks/useACNavigate';
import { SEARCH_QUERY_KEY } from '../constants';
import { isOnResultsPage } from '../utils/isOnResultsPage';
export const useRemoveSearchQuery = () => {
  const navigate = useACNavigate();
  const location = useLocation();
  return useCallback(() => {
    if (!isOnResultsPage(location.pathname)) {
      return;
    }
    const urlSearchParams = new URLSearchParams(location.search);
    urlSearchParams.delete(SEARCH_QUERY_KEY);
    const search = urlSearchParams.size > 0 ? `?${urlSearchParams.toString()}` : '';
    navigate(Object.assign({}, location, {
      search
    }), {
      replace: true
    });
  }, [navigate, location]);
};